import * as React from "react";
import { IconProps } from "./types";

export const ArrowNarrowRightIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M4 12H20M20 12L14 6M20 12L14 18"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(ArrowNarrowRightIcon as React.FunctionComponent).displayName =
  "ArrowNarrowRightIcon";

export default ArrowNarrowRightIcon;
